/**
 * 全局事件总线
 * 用于组件间通信和全局事件处理
 */

// 事件处理器存储
const handlers = new Map();

/**
 * 事件总线对象
 */
const eventBus = {
  /**
   * 触发事件
   * @param {string} event - 事件名称
   * @param {any} data - 事件数据
   */
  emit(event, data) {
    if (handlers.has(event)) {
      handlers.get(event).forEach(handler => {
        try {
          handler(data);
        } catch (error) {
          console.error(`事件处理器错误 [${event}]:`, error);
        }
      });
    }
  },

  /**
   * 注册事件监听器
   * @param {string} event - 事件名称
   * @param {Function} handler - 事件处理函数
   */
  on(event, handler) {
    if (!handlers.has(event)) {
      handlers.set(event, []);
    }
    handlers.get(event).push(handler);
  },

  /**
   * 移除事件监听器
   * @param {string} event - 事件名称
   * @param {Function} handler - 要移除的事件处理函数
   */
  off(event, handler) {
    if (handlers.has(event)) {
      if (handler) {
        // 移除特定处理器
        const eventHandlers = handlers.get(event);
        const index = eventHandlers.indexOf(handler);
        if (index !== -1) {
          eventHandlers.splice(index, 1);
        }
      } else {
        // 移除所有该事件的处理器
        handlers.delete(event);
      }
    }
  },

  /**
   * 只监听一次事件
   * @param {string} event - 事件名称
   * @param {Function} handler - 事件处理函数
   */
  once(event, handler) {
    const onceHandler = (data) => {
      handler(data);
      this.off(event, onceHandler);
    };
    this.on(event, onceHandler);
  }
};

// 预定义的事件类型
export const EventTypes = {
  // 认证相关
  AUTH_LOGIN: 'auth:login',
  AUTH_LOGOUT: 'auth:logout',
  AUTH_TOKEN_EXPIRED: 'auth:token-expired',
  
  // 通知相关
  NOTIFICATION_NEW: 'notification:new',
  NOTIFICATION_READ: 'notification:read',
  
  // 应用状态
  APP_READY: 'app:ready',
  APP_ERROR: 'app:error',
  
  // 素材搜索
  MATERIAL_SEARCH_KEYWORD_CHANGE: 'material:search-keyword-change'
};

export default eventBus;